import React, { createContext, useContext, useState } from "react";
import { ColumnSettingsProps, emptyFunction } from "@cofano/cck";
import TableSaveSettingsDialog from "./TableSaveSettingsDialog";

interface TableContextProps {
	openDialog: (tableKey: string, columnSettings: Array<ColumnSettingsProps>) => void;
}

const TableContext = createContext<TableContextProps>({
	openDialog: emptyFunction,
});

const TableProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const [ dialog, setDialog ] = useState<{
		open: false;
		tableKey: null;
		columnSettings: null;
	} | {
		open: true;
		tableKey: string;
		columnSettings: Array<ColumnSettingsProps>;
	}>({
		open: false,
		tableKey: null,
		columnSettings: null,
	});

	const openDialog = (tableKey: string, columnSettings: Array<ColumnSettingsProps>) => {
		setDialog({ open: true, tableKey, columnSettings });
	};

	return (
		<TableContext.Provider value={{ openDialog }}>
			{children}

			{dialog.open && (
				<TableSaveSettingsDialog
					open={dialog.open}
					onClose={() => setDialog({ open: false, tableKey: null, columnSettings: null })}
					tableKey={dialog.tableKey}
					columnSettings={dialog.columnSettings}
				/>
			)}
		</TableContext.Provider>
	);
};

export const useTableProvider = () => {
	const context = useContext(TableContext);
	return context;
};

export default TableProvider;
